import React, { useEffect, useState } from "react";
import SunEditor from "suneditor-react";// Import SunEditor CSS
import plugins from 'suneditor/src/plugins'

const TextEditor = ({ content, setContent, readOnly=false }) => {

    return (
        <SunEditor
            setContents={content}
            readOnly={readOnly}
            onChange={setContent} // Update state when content changes
            setOptions={{
                height: 400, // Set editor height
                buttonList: [
                    // ["bold", "italic", "underline", "strike"], // Text formatting
                    // ["list", "align", "outdent", "indent"], // Lists and alignment
                    // ["link", "image", "table"], // Link, image, and table support
                    ['undo', 'redo'],
                    ['font', 'fontSize', 'formatBlock'],
                    ['paragraphStyle', 'blockquote'],
                    ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                    ['fontColor', 'hiliteColor', 'textStyle'],
                    ['removeFormat'],
                    ['outdent', 'indent'],
                    ['align', 'horizontalRule', 'list', 'lineHeight'],
                    ['table', 'link', 'image',],
                    ['codeView'],
                    ['preview', 'print'],
                    ['save', 'template'],
                ],
                font: [
                    "Arial", "Helvetica Neue", "Verdana"
                ],
                fontSize: [
                    12, 13, 14
                ],
                plugins: [
                    plugins.blockquote,
                    plugins.image,
                    plugins.link,
                    plugins.video,
                    plugins.audio,
                    plugins.math,
                    plugins.align,
                    plugins.font,
                    plugins.fontColor,
                    plugins.fontSize,
                    plugins.formatBlock,
                    plugins.hiliteColor,
                    plugins.horizontalRule,
                    plugins.lineHeight,
                    plugins.list,
                    plugins.paragraphStyle,
                    plugins.table,
                    plugins.template,
                    plugins.textStyle,
                    plugins.imageGallery

                    //...
                ],
                attributesWhitelist: {
                    table: "style",
                    td: "style",
                    tr: "style",
                },
                addTagsWhitelist: "table",
                // sanitize: false,
                // defaultStyle: "white-space: pre-wrap;",
                // addTagsWhitelist: "pre",
                // addCSSWhitelist: ["white-space: pre-wrap;"],
            }}
        // className='quillContainer'
        />
    );
};

export default TextEditor;
